import { graphql } from 'graphql-schema';

export const UPDATE_GAME_SCORES = graphql(`
  mutation updateGameScores($input: UpdateGameScoreInput!) {
    updateGameScore(input: $input) {
      game
    }
  }
`);
